import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import styles from "../style.module.scss";
import CustomButton from "shared/components/customButton";
import { toastMessage } from "shared/components/toast";
import Loader from "shared/components/loader/animation";

import {
  createTagsService,
  updateTagsService,
} from "shared/services/productManagerService";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AddKeywordProps {
  open: boolean;
  handleClose: any;
  selectedKeyword: any;
  getAllKeywords: any;
}

export default function AddKeyword({
  open,
  handleClose,
  selectedKeyword,
  getAllKeywords,
}: AddKeywordProps) {
  const [keyword, setKeyword] = useState<any>("");
  const [slug, setSlug] = useState<any>("");
  const [description, setDiscription] = useState<any>("");
  const [metaTitle, setMetaTitle] = useState<any>("");
  const [metaDescription, setMetaDescription] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const [icon, setIcon] = useState({
    raw: null,
    preview: selectedKeyword?.icon || "",
  });
  const [banner, setBanner] = useState({
    raw: null,
    preview: selectedKeyword?.banner || "",
  });
  const iconRef = useRef<HTMLInputElement | null>(null);
  const bannerRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (selectedKeyword) {
      console.log("Selected Keyword:", selectedKeyword);
      setKeyword(selectedKeyword?.name);
      setSlug(selectedKeyword?.slug || "");
      setDiscription(selectedKeyword?.description);
      setMetaTitle(
        selectedKeyword?.meta_title || selectedKeyword?.metaTitle || "",
      );
      setMetaDescription(
        selectedKeyword?.meta_description ||
          selectedKeyword?.metaDescription ||
          "",
      );
      setIcon({
        raw: null,
        preview: selectedKeyword?.icon || "",
      });
      setBanner({
        raw: null,
        preview: selectedKeyword?.banner || "",
      });
    } else {
      // Reset states when adding new keyword
      setKeyword("");
      setSlug("");
      setDiscription("");
      setMetaTitle("");
      setMetaDescription("");
      setIcon({ raw: null, preview: "" });
      setBanner({ raw: null, preview: "" });
    }
    // eslint-disable-next-line
  }, [selectedKeyword]);

  const handleSubmit = () => {
    let service = selectedKeyword ? updateTagsService : createTagsService;

    const formData = new FormData();
    formData.append("name", keyword);
    formData.append("slug", slug);
    formData.append("description", description);
    formData.append("meta_title", metaTitle);
    formData.append("meta_description", metaDescription);

    if (icon.raw) {
      formData.append("icon", icon.raw);
    }
    if (banner.raw) {
      formData.append("banner", banner.raw);
    }

    if (selectedKeyword) {
      formData.append("id", selectedKeyword?.id);
    }

    setLoader(true);
    if (keyword.length) {
      service(formData)
        .then(({ data }) => {
          setLoader(false);
          console.log(data, "form data sumitted");
          toastMessage("success", data?.message);
          onClose();
          getAllKeywords();
        })
        .catch((err) => {
          console.log("Err", err?.response?.data?.message);
          toastMessage("error", err?.response?.data?.message);
          setLoader(false);
        });
    } else {
      toastMessage("error", "Please type in something to proceed.");
      setLoader(false);
    }
  };

  const onClose = () => {
    handleClose();
    setKeyword("");
    setSlug("");
    setDiscription("");
    setMetaTitle("");
    setMetaDescription("");
    setIcon({ raw: null, preview: "" });
    setBanner({ raw: null, preview: "" });
  };

  const handleBannerImg = (e: any) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setBanner({
          preview: e.target.result as string,
          raw: file,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleBannerImageDelete = () => {
    setBanner({ preview: "", raw: null });
    if (bannerRef.current) {
      bannerRef.current.value = "";
    }
  };

  const handleImageChange = (e: any) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setIcon({
          preview: e.target.result as string,
          raw: file,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageDelete = () => {
    setIcon({ preview: "", raw: null });
    if (iconRef.current) {
      iconRef.current.value = "";
    }
  };

  const handleButtonClick = () => {
    if (iconRef.current) {
      iconRef.current.click();
    }
  };

  const handleBannerButtonClick = () => {
    if (bannerRef.current) {
      bannerRef.current.click();
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogContent>
          <Icons.CrossIcon
            className={styles.crossIcon}
            onClick={() => handleClose()}
          />

          <div className={styles.categoryTitle}>
            {selectedKeyword ? "Update" : "Add"} Keyword
          </div>
          <label className={styles.label}>
            {selectedKeyword ? "Update" : "Add"} Title
          </label>
          <input
            className={styles.inputCategory}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
          <label className={styles.label} style={{ marginTop: "15px" }}>
            {selectedKeyword ? "Update" : "Add"} Slug
          </label>
          <input
            className={styles.inputCategory}
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            placeholder="e.g., adventure-stories"
          />
          <label className={styles.areaLabel}>
            {selectedKeyword ? "Update" : "Add"} Keyword Description
          </label>

          <textarea
            style={{ width: "100%" }}
            className={styles.textarea}
            onChange={(e) => setDiscription(e.target.value)}
            value={description}
          />

          <label className={styles.label} style={{ marginTop: "15px" }}>
            {selectedKeyword ? "Update" : "Add"} Meta Title
          </label>
          <input
            className={styles.inputCategory}
            value={metaTitle}
            onChange={(e) => setMetaTitle(e.target.value)}
          />

          <label className={styles.areaLabel}>
            {selectedKeyword ? "Update" : "Add"} Meta Description
          </label>
          <textarea
            style={{ width: "100%" }}
            className={styles.textarea}
            onChange={(e) => setMetaDescription(e.target.value)}
            value={metaDescription}
          />

          <div style={{ marginTop: "15px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e)}
              ref={iconRef}
              style={{ display: "none" }}
            />
            <div className={styles.iconImgContainer}>
              {icon?.preview && (
                <Icons.DeleteIcon
                  className={styles.deleteIcon}
                  onClick={() => handleImageDelete()}
                />
              )}
              {icon.preview ? (
                <img
                  src={icon.preview && icon.preview}
                  alt={"Icon"}
                  className={styles.iconImg}
                  onClick={() => handleButtonClick()}
                />
              ) : (
                <div
                  className={`${styles.uploadContainer} ${styles.iconContainer}`}
                  onClick={() => handleButtonClick()}
                >
                  <Icons.UploadFileIcon />
                  <label>Please Upload Icon</label>
                </div>
              )}
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleBannerImg(e)}
              ref={bannerRef}
              style={{ display: "none" }}
            />
            <div className={styles.bannerImgContainer}>
              {banner?.preview && (
                <Icons.DeleteIcon
                  className={styles.deleteIcon}
                  onClick={() => handleBannerImageDelete()}
                />
              )}
              {banner.preview ? (
                <img
                  src={banner.preview && banner.preview}
                  alt={"Keyword Banner"}
                  className={styles.bannerImg}
                  onClick={() => handleBannerButtonClick()}
                />
              ) : (
                <div
                  className={`${styles.uploadContainer} ${styles.bannerContainer}`}
                  onClick={() => handleBannerButtonClick()}
                >
                  <Icons.UploadFileIcon />
                  <label>Please Upload Keyword Banner</label>
                </div>
              )}
            </div>
          </div>

          <div className={styles.btnContainer}>
            <CustomButton
              text={selectedKeyword ? "Update" : "Add"}
              buttonStyle={styles.btnCustom}
              handleClick={() => handleSubmit()}
            />
            <CustomButton
              text="Cancel"
              buttonStyle={styles.btnInsideOut}
              handleClick={() => handleClose()}
            />
          </div>
        </DialogContent>

        {loader && <Loader />}
      </Dialog>
    </div>
  );
}
